import Wikis20 from '@carbon/icons-react/es/wikis/20';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { useTranslation } from 'hooks/use-translation';

const PageContent = styled(Page.Content)`
  padding: var(--layout-03);
  max-width: 768px;

  > .ant-row {
    padding: var(--spacing-03);
  }
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CustomDomainLayout: FC = ({ children }) => {
  const title = useTranslation('custom_domain');
  // const articleText = useTranslation('settings.custom_domain.article.text');

  return (
    <Page>
      <Helmet>{title}</Helmet>
      <Page.Header
        $white
        sticky
        compact
        title={
          <HeaderContent>
            <HeaderWithIconTitle icon={<Wikis20 />} title={title} />
            {/* <LinkButton icon={<Launch16 />}>{articleText}</LinkButton> */}
          </HeaderContent>
        }
      />

      <PageContent>{children}</PageContent>
    </Page>
  );
};
